<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-form>
              <v-card-title class="pb-0">
                <v-layout row wrap></v-layout>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-layout row wrap mt-4>
                  <v-flex xs12 sm6 pa-2>
                    <v-layout column>
                      <label class="pt-3">Merchant Name</label>
                      <v-text-field solo v-model="newMerchant.name" label="Merchant Name"></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 pa-2>
                    <v-layout column>
                      <label class="pt-3">Phone No</label>
                      <v-text-field solo v-model="newMerchant.phone" label="Phone number"></v-text-field>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 pa-2>
                    <v-layout column>
                      <label class="pt-3">Category</label>
                      <v-autocomplete
                        solo
                        v-model="newMerchant.category"
                        :items="categories"
                        item-text="name"
                        item-value="value"
                        label="Category"
                      ></v-autocomplete>
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6 pa-2>
                    <v-layout column>
                      <label class="pt-3">Business Type</label>
                      <v-autocomplete
                        label="Business Type"
                        solo
                        v-model="newMerchant.business_type"
                      ></v-autocomplete>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pb-5">
                <v-flex justify-end pr-3>
                  <v-btn class="primary" @click="goToLocation">
                    <span>Add Location(s)</span>
                    <v-icon small class="ml-2">arrow_forward</v-icon>
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-form>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AdminLayout from "../../../layouts/admin"
import utils from "@/common/utils"

export default {
  name: "CreateMerchant",
  data() {
    return {
      page_title: "New Merchant",
      getDate: new Date(),
      merchantDialog: false,
      selected: "",
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      newMerchant: {
        name: "",
        category: "",
        business_type: "",
        phone: ""
      }
    }
  },
  computed: {
    categories: function() {
      return utils.CATEGORY_CHOICES
    }
  },
  methods: {
    goToLocation() {
      this.$router.push(`/admin/create/merchantLocation`)
    }
  },
  created() {
    this.$emit("update:layout", AdminLayout)
  }
}
</script>


